import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowOrder } from "../../utils";

function RestrictOrder(props) {
  if (IsShowOrder()) return props.children;
  return <NotAccess />;
}

export default RestrictOrder;
